export const ide = {
  inActivityDisconnect: 'ide.pipeline.inactivity.disconnect',
  errorDisconnect: 'ide.pipeline.error.disconnect',
  netWorkChangeDisconnect: 'ide.pipeline.networkChange.disconnect',
  inferFromCluster: 'infer.from.cluster',
  genericUnitTestSave: 'generate.unit.test',
  inferFromSchema: 'infer.the.schema',
  showInterimPreview: 'show.the.preview',
  changeConfiguration: 'change.configurations',
  modifyComponent: 'modified.component',
  openPipeline: 'open.workflow',
  settingsSave: 'options.save',
  switchFabric: 'switch.fabric',
  clusterConnectionStart: 'start.spinning.up.cluster',
  longLivingClusterConnection: 'connect.long.living.cluster',
  empheralClusterConnection: 'connect.existing.cluster',
  editUDF: 'edit.udf.or.udafs',
  changeSubgraphConfiguration: 'change.subgraph.configurations',
  dependencyListOpen: 'dependencies.list.open',
  dependencySave: 'dependency.save',
  pipelineCounterKey: 'pipeline.run.counter',
  processRun: 'interactive.componentLevel.run',
  fullRun: 'interactive.full.run',
  jobScheduleSuccess: 'ide.job.create.success',
  pastedComponent: 'ide.pipeline.paste.success',
  copiedComponentsWithCut: 'ide.pipeline.cut.copied.success',
  pipelineSettingsMount: 'ide.pipeline.settings.open',
  addNewComponent: 'ide.pipeline.add.new.node',
  copiedComponent: 'ide.pipeline.components.copy',
  addReusableSubgraph: 'ide.reusable.subgraph.add',
  createSchedule: 'Workflow editor create schedule',

  //Replay events for a specific pipeline
  replayCopied: 'ide.pipeline.replay.item.copy',
  replayLanded: 'ide.pipeline.replay.landed',
  restartReplayAgain: 'ide.pipeline.replay.restart.again',
  replayWelcomeScreen: 'ide.pipeline.replay.welcome.start',
  replayValidationStarted: 'ide.pipeline.replay.validationStarted',
  replayValidationDone: 'ide.pipeline.replay.validationDone',
  replayCommitIdDataLoaded: 'ide.pipeline.replay.commitId.data.loaded',
  replayOnboardingResume: 'ide.pipeline.replay.onboarding.resume',
  replayOnboardingStart: 'ide.pipeline.replay.onboarding.start',
  replaySetPreviousState: 'ide.pipeline.replay.setPrevious.state',
  replayStopResumeNotification: 'ide.pipeline.replay.pause.resume.notification',
  replayPublished: 'ide.pipeline.replay.item.publish',
  replayPublishUpdate: 'ide.pipeline.replay.item.publish.updated',
  replayNew: 'ide.pipeline.replay.item.new',
  replayEdit: 'ide.pipeline.replay.item.edit',
  replayExit: 'ide.pipeline.replay.exit',
  replayStepChange: 'ide.pipeline.replay.step.change',
  replayStepCommitChange: 'ide.pipeline.replay.step.commit.change',
  replayTestUpdate: 'ide.pipeline.replay.step.testcase.change',
  replayStart: 'ide.pipeline.replay.start',
  replayPause: 'ide.pipeline.replay.pause',
  replayCompleted: 'ide.pipeline.replay.completed',
  replaysLoaded: 'ide.pipeline.replays.loaded',
  replayDeleted: 'ide.pipeline.replay.deleted',
  replayStepTestUpdate: 'ide.pipeline.replay.step.test.update',
  replayStepAdd: 'ide.pipeline.replay.step.add',
  replayStepDelete: 'ide.pipeline.replay.step.delete',
  replayStepUpdateSave: 'ide.pipeline.replay.step.updateSave',
  replayStepUpdateCancel: 'ide.pipeline.replay.step.updateCancel'
};

export const metadata = {
  createPipelineLanding: 'metadata.create.pipeline',
  pipelineCreationFailed: 'pipeline.entity.creation.failed',
  pipelineCreationSuccess: 'pipeline.entity.creation.successful',
  pipelineDescriptionUpdate: 'aspects.updated.for.pipeline',
  pipelineDescriptionUpdateFailed: 'aspects.update.failed.for.pipeline'
};
